import { budgetSummary } from './budgetSummary';
import { cardForm } from './cardForm';
import { checkoutCustomerRegistration } from './checkoutCustomerRegistration';
import { completeRegistrationForm } from './completeRegistrationForm';
import { components } from './components';
import { paymentLink } from './paymentLink';

const es = {
  ...budgetSummary,
  ...paymentLink,
  ...cardForm,
  ...completeRegistrationForm,
  ...components,
  ...checkoutCustomerRegistration,
};

export default es;
